/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiV3ServiceGetLinkedCardsGet } from '../fn/link-card/api-v-3-service-get-linked-cards-get';
import { ApiV3ServiceGetLinkedCardsGet$Params } from '../fn/link-card/api-v-3-service-get-linked-cards-get';
import { apiV3ServiceLinkCardGet } from '../fn/link-card/api-v-3-service-link-card-get';
import { ApiV3ServiceLinkCardGet$Params } from '../fn/link-card/api-v-3-service-link-card-get';
import { apiV3ServiceUnlinkCardGet } from '../fn/link-card/api-v-3-service-unlink-card-get';
import { ApiV3ServiceUnlinkCardGet$Params } from '../fn/link-card/api-v-3-service-unlink-card-get';

@Injectable({ providedIn: 'root' })
export class ApiFromLinkCardService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiV3ServiceLinkCardGet()` */
  static readonly ApiV3ServiceLinkCardGetPath = '/api/v3/service/linkCard';

  /**
   * Linking a bank card.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceLinkCardGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceLinkCardGet$Response(params?: ApiV3ServiceLinkCardGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceLinkCardGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Linking a bank card.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceLinkCardGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceLinkCardGet(params?: ApiV3ServiceLinkCardGet$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceLinkCardGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceUnlinkCardGet()` */
  static readonly ApiV3ServiceUnlinkCardGetPath = '/api/v3/service/unlinkCard';

  /**
   * Unlinking a bank card.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceUnlinkCardGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceUnlinkCardGet$Response(params?: ApiV3ServiceUnlinkCardGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceUnlinkCardGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Unlinking a bank card.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceUnlinkCardGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceUnlinkCardGet(params?: ApiV3ServiceUnlinkCardGet$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceUnlinkCardGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `apiV3ServiceGetLinkedCardsGet()` */
  static readonly ApiV3ServiceGetLinkedCardsGetPath = '/api/v3/service/getLinkedCards';

  /**
   * Getting a list of bank cards.
   *
   *
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiV3ServiceGetLinkedCardsGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetLinkedCardsGet$Response(params?: ApiV3ServiceGetLinkedCardsGet$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    return apiV3ServiceGetLinkedCardsGet(this.http, this.rootUrl, params, context);
  }

  /**
   * Getting a list of bank cards.
   *
   *
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiV3ServiceGetLinkedCardsGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiV3ServiceGetLinkedCardsGet(params?: ApiV3ServiceGetLinkedCardsGet$Params, context?: HttpContext): Observable<void> {
    return this.apiV3ServiceGetLinkedCardsGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

}
